/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable object-curly-newline */
/* eslint-disable prefer-template */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Collapse from './Minimize_Button_2x.png';
import './ModalHeader.scss';

const propTypes = {
  toggle: PropTypes.func.isRequired,
  classes: PropTypes.string,
  closeAriaLabel: PropTypes.string,
};

const defaultProps = {
  closeAriaLabel: 'Close',
};

const ModalHeader = ({ classes, toggle, closeAriaLabel }) => (
  <button type="button" onClick={toggle} className={cx('modal-header', 'close', classes && classes)} aria-label={closeAriaLabel}>
    <img src={Collapse} alt="collapse" />
  </button>
);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;

export default ModalHeader;
